import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const ChevronRightTwo: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M1.5 8.75L4.5 5l-3-3.75"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </SVGIcon>
);

export default ChevronRightTwo;
